import { useContext } from 'react';
import type {
  IndicatorProps as ReactSelectIndicatorProps,
  OptionTypeBase,
} from 'react-select';

import { Divider, type DividerProps } from '@frontend/components';

import { SelectContext } from '../SelectContext';

export type IndicatorSeparatorProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectIndicatorProps<OptionType, IsMulti> & {
  innerProps?: DividerProps;
};

export const IndicatorSeparator = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
}: IndicatorSeparatorProps<OptionType, IsMulti>) => {
  const { hasSuggestions, hasAcceptedSuggestions, hasRejectedSuggestions } =
    useContext(SelectContext);
  return (
    <Divider
      __css={{
        ...(hasSuggestions && !hasAcceptedSuggestions && !hasRejectedSuggestions
          ? { borderColor: 'interaction.suggestion' }
          : null),
      }}
      {...innerProps}
      orientation="vertical"
      opacity="1"
      h="65%"
    />
  );
};
